<template>
  <div class="comp-settings">
    <h1 class="headline">SETTINGS</h1>

    <div class="tabs">
      <ul>
        <li v-for="(tab, index) in tabs" :key="index">
          <router-link :to="{name: tab.value}"
                       :class="{active: $route.name == tab.value}">{{ tab.label }}</router-link>
        </li>
      </ul>
    </div>

    <router-view></router-view>

  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    components: {
    },
    data () {
      return {
        tabs: [],
      }
    },
    watch: {},
    computed: {
      ...mapGetters(['CURRENT_USER', 'IS_CLIENT', 'IS_CLIENT_MANAGER']),
    },
    created () {},
    mounted () {
      this.init();
    },
    methods: {
      init () {
        let self = this;
        if (!self.IS_CLIENT) {
          self.tabs = [
            {value: 'settings', label: 'COMPANY'},
            {value: 'settings-team', label: 'TEAM'},
            {value: 'settings-user-types', label: 'USER TYPES' },
            {value: 'settings-cost-categories', label: 'COST CATEGORIES' },
            {value: 'settings-cost-matrix', label: 'COST MATRIX' },
            {value: 'settings-client-users', label: 'CLIENT USERS' },
            {value: 'settings-xero', label: 'XERO'},
            {value: 'settings-email-templates', label: 'EMAIL TEMPLATES'},
          ];
        } else if (self.IS_CLIENT_MANAGER) {
          self.tabs = [
            {value: 'settings', label: 'COMPANY'},
            {value: 'settings-client-users', label: 'CLIENT USERS' }
          ];
        }
      }
    }
  }
</script>
